import { render } from "./DField.vue?vue&type=template&id=4f0775e2"
import script from "./DField.vue?vue&type=script&lang=ts"
export * from "./DField.vue?vue&type=script&lang=ts"
script.render = render

export default script